export const FinancialAdvisorEstateCypressAttribute = {
  views: {
    OPPORTUNITIES_TABLE: 'FinancialAdvisorEstateCypressAttribute:views:OPPORTUNITIES_TABLE',
    TABLE_CLIENT_CELL_TEXT: 'FinancialAdvisorEstateCypressAttribute:views:TABLE_CLIENT_CELL_TEXT',
    OPPORTUNITIES_FREE_SCAN_EMPTY_STATE:
      'FinancialAdvisorEstateCypressAttribute:views:OPPORTUNITIES_FREE_SCAN_EMPTY_STATE',
    ADVISOR_PRO_UPGRADE_BANNER:
      'FinancialAdvisorEstateCypressAttribute:views:ADVISOR_PRO_UPGRADE_BANNER'
  },
  buttons: {
    SCAN_FOR_NEW_OPPORTUNITIES:
      'FinancialAdvisorEstateCypressAttribute:buttons:SCAN_FOR_NEW_OPPORTUNITIES',
    REVIEWED_BY_FILTER_TOGGLE:
      'FinancialAdvisorEstateCypressAttribute:buttons:REVIEWED_BY_FILTER_TOGGLE',
    RUN_FREE_SCAN: 'FinancialAdvisorEstateCypressAttribute:buttons:RUN_FREE_SCAN'
  },
  clientJourney: {
    views: {
      PRE_REFERRAL_CHECKPOINTS_LIST:
        'FinancialAdvisorEstateCypressAttribute:clientJourney:views:PRE_REFERRAL_CHECKPOINTS_LIST',
      PRE_REFERRAL_CHECKPOINTS_LIST_HEADER:
        'FinancialAdvisorEstateCypressAttribute:clientJourney:views:PRE_REFERRAL_CHECKPOINTS_LIST_HEADER',
      POST_REFERRAL_CHECKPOINTS_LIST:
        'FinancialAdvisorEstateCypressAttribute:clientJourney:views:POST_REFERRAL_CHECKPOINTS_LIST',
      PRE_REFERRAL_CHECKPOINTS_COLLAPSE:
        'FinancialAdvisorEstateCypressAttribute:clientJourney:views:PRE_REFERRAL_CHECKPOINTS_COLLAPSE',
      POST_REFERRAL_CHECKPOINTS_COLLAPSE:
        'FinancialAdvisorEstateCypressAttribute:clientJourney:views:POST_REFERRAL_CHECKPOINTS_COLLAPSE'
    },
    buttons: {
      SHOW_POST_REFERRAL_STEPS:
        'FinancialAdvisorEstateCypressAttribute:clientJourney:buttons:SHOW_POST_REFERRAL_STEPS',
      SHOW_HISTORY: 'FinancialAdvisorEstateCypressAttribute:clientJourney:buttons:SHOW_HISTORY'
    }
  },
  planning: {
    buttons: {
      REFER_CLIENT: 'FinancialAdvisorEstateCypressAttribute:planning:buttons:REFER_CLIENT',
      REFER_CLIENT_EMPTY_STATE:
        'FinancialAdvisorEstateCypressAttribute:planning:buttons:REFER_CLIENT_EMPTY_STATE',
      VIEW_SOLUTIONS_AND_PRICING:
        'FinancialAdvisorEstateCypressAttribute:planning:buttons:VIEW_SOLUTIONS_AND_PRICING',
      ADVISOR_PRO_UPGRADE_BUTTON:
        'FinancialAdvisorEstateCypressAttribute:nav:buttons:ADVISOR_PRO_UPGRADE_BUTTON',
      MOVE_TO_TEAM: 'FinancialAdvisorEstateCypressAttribute:planning:buttons:MOVE_TO_TEAM'
    },
    views: {
      PLANNING_DASHBOARD:
        'FinancialAdvisorEstateCypressAttribute:planning:views:PLANNING_DASHBOARD',
      FINANCIAL_ADVISOR_PLANNING:
        'FinancialAdvisorEstateCypressAttribute:planning:views:FINANCIAL_ADVISOR_PLANNING',
      PLANNING_REFERRALS_TABLE:
        'FinancialAdvisorEstateCypressAttribute:planning:views:PLANNING_REFERRALS_TABLE',
      ARCHIVED_PLANNING_REFERRALS_TABLE:
        'FinancialAdvisorEstateCypressAttribute:planning:views:ARCHIVED_PLANNING_REFERRALS_TABLE',
      SETTLEMENT_DASHBOARD:
        'FinancialAdvisorEstateCypressAttribute:planning:views:SETTLEMENT_DASHBOARD',
      DEMO_PLATFORM: 'FinancialAdvisorEstateCypressAttribute:planning:views:DEMO_PLATFORM',
      SOLUTIONS_AND_PRICING:
        'FinancialAdvisorEstateCypressAttribute:planning:views:SOLUTIONS_AND_PRICING',
      LOADING: 'FinancialAdvisorEstateCypressAttribute:planning:views:LOADING',
      REFERRALS_EMPTY_STATE:
        'FinancialAdvisorEstateCypressAttribute:planning:views:REFERRALS_EMPTY_STATE',
      ADVISOR_PRO_UPGRADE_LINK:
        'FinancialAdvisorEstateCypressAttribute:planning:views:ADVISOR_PRO_UPGRADE_LINK'
    }
  },
  team: {
    buttons: {
      CREATE_TEAM: 'FinancialAdvisorEstateCypressAttribute:team:buttons:CREATE_TEAM'
    },
    views: {
      TEAMS_DASHBOARD_EMPTY_STATE_FR_IMAGE:
        'FinancialAdvisorEstateCypressAttribute:teams:TEAMS_DASHBOARD_EMPTY_STATE_FR_IMAGE',
      TEAMS_DASHBOARD_EMPTY_STATE_EN_IMAGE:
        'FinancialAdvisorEstateCypressAttribute:teams:TEAMS_DASHBOARD_EMPTY_STATE_EN_IMAGE',
      TEAMS_DASHBOARD_EMPTY_STATE:
        'FinancialAdvisorEstateCypressAttribute:teams:TEAMS_DASHBOARD_EMPTY_STATE'
    }
  },
  documents: {
    views: {
      PRO_UPGRADE_BANNER:
        'FinancialAdvisorEstateCypressAttribute:documents:views:PRO_UPGRADE_BANNER',
      PRO_UPGRADE_BANNER_SKELETON:
        'FinancialAdvisorEstateCypressAttribute:documents:views:PRO_UPGRADE_BANNER_SKELETON',
      CLARA_DOCUMENT_ANALYSIS_EMPTY_STATE:
        'FinancialAdvisorEstateCypressAttribute:documents:views:CLARA_DOCUMENT_ANALYSIS_EMPTY_STATE',
      ADD_DOCUMENT_BUTTON:
        'FinancialAdvisorEstateCypressAttribute:documents:views:ADD_DOCUMENT_BUTTON',
      DOCUMENT_ROW_THUMBNAIL:
        'FinancialAdvisorEstateCypressAttribute:documents:views:DOCUMENT_ROW_THUMBNAIL',
      DOCUMENT_ROW_FILE_ICON:
        'FinancialAdvisorEstateCypressAttribute:documents:views:DOCUMENT_ROW_FILE_ICON',
      DOCUMENT_ROW_NAME: 'FinancialAdvisorEstateCypressAttribute:documents:views:DOCUMENT_ROW_NAME',
      DOCUMENT_ROW_META: 'FinancialAdvisorEstateCypressAttribute:documents:views:DOCUMENT_ROW_META',
      ANALYSIS_FAILED_TAG:
        'FinancialAdvisorEstateCypressAttribute:documents:views:ANALYSIS_FAILED_TAG'
    },
    buttons: {
      PRO_UPGRADE_BUTTON:
        'FinancialAdvisorEstateCypressAttribute:documents:buttons:PRO_UPGRADE_BUTTON',
      PRO_DISMISS_BUTTON:
        'FinancialAdvisorEstateCypressAttribute:documents:buttons:PRO_DISMISS_BUTTON',
      ANALYZE_WITH_CLARA:
        'FinancialAdvisorEstateCypressAttribute:documents:buttons:ANALYZE_WITH_CLARA',
      ANALYSIS_STATUS_BUTTON:
        'FinancialAdvisorEstateCypressAttribute:documents:buttons:ANALYSIS_STATUS_BUTTON',
      DOCUMENT_ROW_DELETE:
        'FinancialAdvisorEstateCypressAttribute:documents:buttons:DOCUMENT_ROW_DELETE'
    }
  },
  manage: {
    views: {
      OVERVIEW_ESTATE_TABS:
        'FinancialAdvisorEstateCypressAttribute:manage:views:OVERVIEW_ESTATE_TABS',
      CLEAR_VAULT_PAGE_TABLE:
        'FinancialAdvisorEstateCypressAttribute:manage:views:CLEAR_VAULT_PAGE_TABLE',
      CLEAR_ESTATE_PAGE_TABLE:
        'FinancialAdvisorEstateCypressAttribute:manage:views:CLEAR_ESTATE_PAGE_TABLE',
      TABLE_NAME_CELL_TEXT:
        'FinancialAdvisorEstateCypressAttribute:manage:views:TABLE_NAME_CELL_TEXT',
      TABLE_EMAIL_CELL_TEXT:
        'FinancialAdvisorEstateCypressAttribute:manage:views:TABLE_EMAIL_CELL_TEXT',
      TABLE_PLAN_REFERRED_BY_TEXT:
        'FinancialAdvisorEstateCypressAttribute:manage:views:TABLE_PLAN_REFERRED_BY_TEXT',
      TABLE_PLAN_UNPAID_TOOLTIP:
        'FinancialAdvisorEstateCypressAttribute:manage:views:TABLE_PLAN_UNPAID_TOOLTIP',
      TABLE_MILESTONE_HEADER_TOOLTIP_ICON:
        'FinancialAdvisorEstateCypressAttribute:manage:views:TABLE_MILESTONE_HEADER_TOOLTIP_ICON',
      TABLE_MILESTONE_HEADER_TOOLTIP_POPOVER:
        'FinancialAdvisorEstateCypressAttribute:manage:views:TABLE_MILESTONE_HEADER_TOOLTIP_POPOVER',
      FINANCIAL_ADVISOR_MILESTONE_STATUS:
        'FinancialAdvisorEstateCypressAttribute:manage:views:FINANCIAL_ADVISOR_MILESTONE_STATUS',
      TABLE_CREATED_AT_HEADER_TOOLTIP_ICON:
        'FinancialAdvisorEstateCypressAttribute:manage:views:TABLE_CREATED_AT_HEADER_TOOLTIP_ICON',
      TABLE_CREATED_AT_HEADER_TOOLTIP_POPOVER:
        'FinancialAdvisorEstateCypressAttribute:manage:views:TABLE_CREATED_AT_HEADER_TOOLTIP_POPOVER',
      ESTATE_MANAGE_SUMMARY_PAGE:
        'FinancialAdvisorEstateCypressAttribute:views:ESTATE_MANAGE_SUMMARY_PAGE',
      ESTATE_MANAGE_SUMMARY_PAGE_HEADER_FULL_NAME:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_SUMMARY_PAGE_HEADER_FULL_NAME',
      ESTATE_MANAGE_SUMMARY_PAGE_BREADCRUMBS:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_SUMMARY_PAGE_BREADCRUMBS',
      ESTATE_MANAGE_SUMMARY_FINANCIALS_TAB_HEADER:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_SUMMARY_FINANCIALS_TAB_HEADER',
      ESTATE_MANAGE_SUMMARY_FAMILY_TREE_TAB_HEADER:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_SUMMARY_FAMILY_TREE_TAB_HEADER',
      ESTATE_MANAGE_SUMMARY_FAMILY_TREE_TAB_CONTENT:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_SUMMARY_FAMILY_TREE_TAB_CONTENT',
      ESTATE_MANAGE_SUMMARY_OPPORTUNITIES_TAB_HEADER:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_SUMMARY_OPPORTUNITIES_TAB_HEADER',
      ESTATE_MANAGE_SUMMARY_DOCUMENTS_TAB_HEADER:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_SUMMARY_DOCUMENTS_TAB_HEADER',
      ESTATE_MANAGE_SUMMARY_DOCUMENTS_TAB_CONTENT:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_SUMMARY_DOCUMENTS_TAB_CONTENT',
      ESTATE_MANAGE_SUMMARY_FINANCIALS_TAB_CONTENT:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_SUMMARY_FINANCIALS_TAB_CONTENT',
      ADVISOR_PRO_BADGE: 'FinancialAdvisorEstateCypressAttribute:manage:views:ADVISOR_PRO_BADGE',
      ADVISOR_PRO_LOCK_ICON:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ADVISOR_PRO_LOCK_ICON',
      FINANCIALS_EMPTY_STATE:
        'FinancialAdvisorEstateCypressAttribute:manage:views:FINANCIALS_EMPTY_STATE',
      FINANCIALS_INVENTORY_ASSETS_TAB:
        'FinancialAdvisorEstateCypressAttribute:manage:views:FINANCIALS_INVENTORY_ASSETS_TAB',
      FINANCIALS_INVENTORY_LIABILITIES_TAB:
        'FinancialAdvisorEstateCypressAttribute:manage:views:FINANCIALS_INVENTORY_LIABILITIES_TAB',
      FINANCIALS_INVENTORY_ASSETS_TAB_HEADER:
        'FinancialAdvisorEstateCypressAttribute:manage:views:FINANCIALS_INVENTORY_ASSETS_TAB_HEADER',
      FINANCIALS_INVENTORY_LIABILITIES_TAB_HEADER:
        'FinancialAdvisorEstateCypressAttribute:manage:views:FINANCIALS_INVENTORY_LIABILITIES_TAB_HEADER',
      FAMILY_TREE_EMPTY_STATE:
        'FinancialAdvisorEstateCypressAttribute:manage:views:FAMILY_TREE_EMPTY_STATE',
      NO_CONSENT_EMPTY_STATE:
        'FinancialAdvisorEstateCypressAttribute:manage:views:NO_CONSENT_EMPTY_STATE',
      ESTATE_MANAGE_PLANNING_CARD_REFERRAL_STATUS:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_PLANNING_CARD_REFERRAL_STATUS',
      ESTATE_MANAGE_MEETING_SECTION:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_MEETING_SECTION',
      ESTATE_MANAGE_MEETING_BOOKED:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_MEETING_BOOKED',
      ESTATE_MANAGE_MEETING_BOOKED_DATE:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_MEETING_BOOKED_DATE',
      ESTATE_MANAGE_MEETING_BOOKED_TITLE:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_MEETING_BOOKED_TITLE',
      ESTATE_MANAGE_MEETING_BOOKED_TIME:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_MEETING_BOOKED_TIME',
      ESTATE_MANAGE_MEETING_BOOKED_ATTENDEES:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_MEETING_BOOKED_ATTENDEES',
      ESTATE_MANAGE_PLAN_SELECT_ANOTHER_TOOLTIP:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_PLAN_SELECT_ANOTHER_TOOLTIP',
      ESTATE_MANAGE_PLAN_SELECTED:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_PLAN_SELECTED',
      ESTATE_MANAGE_PLAN_SELECTED_NAME:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_PLAN_SELECTED_NAME',
      ESTATE_MANAGE_PLAN_SELECTED_SUBTITLE:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_PLAN_SELECTED_SUBTITLE',
      ESTATE_MANAGE_SUMMARY_TAB_LEFT_COLUMN:
        'FinancialAdvisorEstateCypressAttribute:manage:views:ESTATE_MANAGE_SUMMARY_TAB_LEFT_COLUMN'
    },
    inputs: {
      CLEAR_VAULT_FILTER_TOGGLE:
        'FinancialAdvisorEstateCypressAttribute:manage:inputs:CLEAR_VAULT_FILTER_TOGGLE',
      CLEAR_ESTATE_FILTER_TOGGLE:
        'FinancialAdvisorEstateCypressAttribute:manage:inputs:CLEAR_ESTATE_FILTER_TOGGLE',
      INVITATION_STATUS_FILTER_TOGGLE:
        'FinancialAdvisorEstateCypressAttribute:manage:inputs:INVITATION_STATUS_FILTER_TOGGLE'
    },
    buttons: {
      ADD_PLAN_REFERRAL_FORM_BUTTON:
        'FinancialAdvisorEstateCypressAttribute:manage:buttons:ADD_PLAN_REFERRAL_FORM_BUTTON',
      ADD_CLIENT_BUTTON: 'FinancialAdvisorEstateCypressAttribute:manage:buttons:ADD_CLIENT_BUTTON',
      MOVE_TO_PRIVATE_SPACE:
        'FinancialAdvisorEstateCypressAttribute:manage:buttons:MOVE_TO_PRIVATE_SPACE',
      MOVE_TO_TEAM: 'FinancialAdvisorEstateCypressAttribute:manage:buttons:MOVE_TO_TEAM',
      OPEN_VAULT: 'FinancialAdvisorEstateCypressAttribute:manage:buttons:OPEN_VAULT',
      ESTATE_MANAGE_PLAN_REFER_CLIENT:
        'FinancialAdvisorEstateCypressAttribute:manage:buttons:ESTATE_MANAGE_PLAN_REFER_CLIENT',
      ESTATE_MANAGE_PLAN_SELECT_ANOTHER:
        'FinancialAdvisorEstateCypressAttribute:manage:buttons:ESTATE_MANAGE_PLAN_SELECT_ANOTHER',
      ESTATE_MANAGE_PLAN_HELP_FIND_PLAN:
        'FinancialAdvisorEstateCypressAttribute:manage:buttons:ESTATE_MANAGE_PLAN_HELP_FIND_PLAN',
      BOOK_CALL: 'FinancialAdvisorEstateCypressAttribute:manage:buttons:BOOK_CALL',
      ESTATE_MANAGE_MEETING_JOIN_CALL:
        'FinancialAdvisorEstateCypressAttribute:manage:buttons:ESTATE_MANAGE_MEETING_JOIN_CALL',
      ESTATE_MANAGE_MEETING_RESCHEDULE:
        'FinancialAdvisorEstateCypressAttribute:manage:buttons:ESTATE_MANAGE_MEETING_RESCHEDULE'
    }
  },
  nav: {
    buttons: {
      ADVISOR_PRO_UPGRADE_ICON_BUTTON:
        'FinancialAdvisorEstateCypressAttribute:nav:buttons:ADVISOR_PRO_UPGRADE_ICON_BUTTON',
      ADVISOR_PRO_UPGRADE_NOT_INTERESTED_BUTTON:
        'FinancialAdvisorEstateCypressAttribute:nav:buttons:ADVISOR_PRO_UPGRADE_NOT_INTERESTED_BUTTON'
    },
    views: {
      ADVISOR_PRO_UPGRADE_CONTENT:
        'FinancialAdvisorEstateCypressAttribute:nav:views:ADVISOR_PRO_UPGRADE_CONTENT'
    }
  },
  dashboard: {
    views: {
      FINANCIAL_ADVISOR_DASHBOARD:
        'FinancialAdvisorEstateCypressAttribute:dashboard:views:FINANCIAL_ADVISOR_DASHBOARD',
      FINANCIAL_ADVISOR_PRO_DASHBOARD:
        'FinancialAdvisorEstateCypressAttribute:dashboard:views:FINANCIAL_ADVISOR_PRO_DASHBOARD',
      FINANCIAL_ADVISOR_PRO_WIDGET_LOCKED_BODY:
        'FinancialAdvisorEstateCypressAttribute:dashboard:views:FINANCIAL_ADVISOR_PRO_WIDGET_LOCKED_BODY',
      FINANCIAL_ADVISOR_PRO_WIDGET_EMPTY_BODY:
        'FinancialAdvisorEstateCypressAttribute:dashboard:views:FINANCIAL_ADVISOR_PRO_WIDGET_EMPTY_BODY',
      FINANCIAL_ADVISOR_PRO_WIDGET_VIEW_DETAILS:
        'FinancialAdvisorEstateCypressAttribute:dashboard:views:FINANCIAL_ADVISOR_PRO_WIDGET_VIEW_DETAILS',
      FINANCIAL_ADVISOR_PRO_AVAILABLE_FREE_WILLS_COUNT:
        'FinancialAdvisorEstateCypressAttribute:dashboard:views:FINANCIAL_ADVISOR_PRO_AVAILABLE_FREE_WILLS_COUNT',
      FINANCIAL_ADVISOR_PRO_TOTAL_FREE_WILLS_COUNT:
        'FinancialAdvisorEstateCypressAttribute:dashboard:views:FINANCIAL_ADVISOR_PRO_TOTAL_FREE_WILLS_COUNT',
      FREE_WILLS_OVERVIEW_WIDGET:
        'FinancialAdvisorEstateCypressAttribute:dashboard:views:FREE_WILLS_OVERVIEW_WIDGET',
      UNREVIEWED_OPPORTUNITIES_OVERVIEW_WIDGET:
        'FinancialAdvisorEstateCypressAttribute:dashboard:views:UNREVIEWED_OPPORTUNITIES_OVERVIEW_WIDGET'
    }
  },
  modal: {
    views: {
      DELETE_COUPLES_BODY_TEXT:
        'FinancialAdvisorEstateCypressAttribute:modal:views:DELETE_COUPLES_BODY_TEXT',
      DELETE_COUPLES_BODY: 'FinancialAdvisorEstateCypressAttribute:modal:views:DELETE_COUPLES_BODY',
      SOLUTIONS_AND_PRICING_MODAL:
        'FinancialAdvisorEstateCypressAttribute:modal:views:SOLUTIONS_AND_PRICING_MODAL',
      JURISDICTION_SELECT: 'FinancialAdvisorEstateCypressAttribute:modal:views:JURISDICTION_SELECT',
      JURISDICTION_BUTTON: 'FinancialAdvisorEstateCypressAttribute:modal:views:JURISDICTION_BUTTON',
      PLAN_PARTY_TYPE_SELECT:
        'FinancialAdvisorEstateCypressAttribute:modal:views:PLAN_PARTY_TYPE_SELECT',
      BILLING_CARD_LOADING:
        'FinancialAdvisorEstateCypressAttribute:modal:views:BILLING_CARD_LOADING',
      ADVISOR_PRO_UPSELL_MODAL:
        'FinancialAdvisorEstateCypressAttribute:modal:views:ADVISOR_PRO_UPSELL_MODAL',
      ADVISOR_PRO_UPSELL_HERO_BAND:
        'FinancialAdvisorEstateCypressAttribute:modal:views:ADVISOR_PRO_UPSELL_HERO_BAND',
      ADVISOR_PRO_UPSELL_PRICING_CARD:
        'FinancialAdvisorEstateCypressAttribute:modal:views:ADVISOR_PRO_UPSELL_PRICING_CARD',
      ADVISOR_PRO_UPSELL_GUARANTEE_BADGE:
        'FinancialAdvisorEstateCypressAttribute:modal:views:ADVISOR_PRO_UPSELL_GUARANTEE_BADGE',
      ADVISOR_PRO_UPSELL_WALKTHROUGH_BAND:
        'FinancialAdvisorEstateCypressAttribute:modal:views:ADVISOR_PRO_UPSELL_WALKTHROUGH_BAND',
      ADVISOR_PRO_UPSELL_WALKTHROUGH_VIDEO_SLOT:
        'FinancialAdvisorEstateCypressAttribute:modal:views:ADVISOR_PRO_UPSELL_WALKTHROUGH_VIDEO_SLOT',
      ADVISOR_PRO_UPSELL_FEATURE_GRID:
        'FinancialAdvisorEstateCypressAttribute:modal:views:ADVISOR_PRO_UPSELL_FEATURE_GRID',
      ADVISOR_PRO_UPSELL_FAQ_SECTION:
        'FinancialAdvisorEstateCypressAttribute:modal:views:ADVISOR_PRO_UPSELL_FAQ_SECTION',
      ADVISOR_PRO_UPSELL_FREE_WILLS_MODAL:
        'FinancialAdvisorEstateCypressAttribute:modal:views:ADVISOR_PRO_UPSELL_FREE_WILLS_MODAL',
      DELETE_DOCUMENT_MODAL:
        'FinancialAdvisorEstateCypressAttribute:modal:views:DELETE_DOCUMENT_MODAL',
      ESTATE_MANAGE_LIGHT_DIAGNOSTIC_MODAL:
        'FinancialAdvisorEstateCypressAttribute:modal:views:ESTATE_MANAGE_LIGHT_DIAGNOSTIC_MODAL'
    },
    buttons: {
      GET_PLAN: 'FinancialAdvisorEstateCypressAttribute:modal:buttons:GET_PLAN',
      GET_MONTHLY_PLAN: 'FinancialAdvisorEstateCypressAttribute:modal:buttons:GET_MONTHLY_PLAN',
      ADVISOR_PRO_UPSELL_GRID_CTA:
        'FinancialAdvisorEstateCypressAttribute:modal:buttons:ADVISOR_PRO_UPSELL_GRID_CTA',
      ADVISOR_PRO_UPSELL_WILLS_SEE_MORE:
        'FinancialAdvisorEstateCypressAttribute:modal:buttons:ADVISOR_PRO_UPSELL_WILLS_SEE_MORE'
    }
  },
  form: {
    inputs: {
      PARTNERSHIP_INVITE_CLIENT_EMAIL:
        'FinancialAdvisorEstateCypressAttribute:form:inputs:PARTNERSHIP_INVITE_CLIENT_EMAIL',
      PARTNERSHIP_INVITE_CLIENT_IS_EMPLOYEE:
        'FinancialAdvisorEstateCypressAttribute:form:inputs:PARTNERSHIP_INVITE_CLIENT_IS_EMPLOYEE',
      PARTNERSHIP_INVITE_CLIENT_SET_LANGUAGE:
        'FinancialAdvisorEstateCypressAttribute:form:inputs:PARTNERSHIP_INVITE_CLIENT_SET_LANGUAGE',
      PHONE_NUMBER: 'FinancialAdvisorEstateCypressAttribute:form:inputs:PHONE_NUMBER',
      REFER_CLIENT_EXECUTOR:
        'FinancialAdvisorEstateCypressAttribute:form:inputs:REFER_CLIENT_EXECUTOR',
      REFER_CLIENT_AS_EXECUTOR:
        'FinancialAdvisorEstateCypressAttribute:form:inputs:REFER_CLIENT_AS_EXECUTOR',
      PARTNERSHIP_INVITE_CLIENT_JURISDICTION:
        'FinancialAdvisorEstateCypressAttribute:form:inputs:PARTNERSHIP_INVITE_CLIENT_JURISDICTION',
      PARTNERSHIP_ADVISOR_SELECT:
        'FinancialAdvisorEstateCypressAttribute:form:inputs:PARTNERSHIP_ADVISOR_SELECT'
    },
    views: {
      PARTNERSHIP_INVITE_CLIENT_1:
        'FinancialAdvisorEstateCypressAttribute:form:views:PARTNERSHIP_INVITE_CLIENT_1',
      PARTNERSHIP_INVITE_CLIENT_2:
        'FinancialAdvisorEstateCypressAttribute:form:views:PARTNERSHIP_INVITE_CLIENT_2'
    }
  },
  onboarding: {
    buttons: {
      CLOSE: 'FinancialAdvisorEstateCypressAttribute:onboarding:buttons:CLOSE',
      GET_STARTED: 'FinancialAdvisorEstateCypressAttribute:onboarding:buttons:GET_STARTED',
      REFERRAL_GUIDE: 'FinancialAdvisorEstateCypressAttribute:onboarding:buttons:REFERRAL_GUIDE',
      DISCOVER_YOUR_PORTAL:
        'FinancialAdvisorEstateCypressAttribute:onboarding:buttons:DISCOVER_YOUR_PORTAL'
    },
    views: {
      REGISTER_CARD: 'FinancialAdvisorEstateCypressAttribute:onboarding:views:REGISTER_CARD',
      HELP_CENTRE_CARD: 'FinancialAdvisorEstateCypressAttribute:onboarding:views:HELP_CENTRE_CARD',
      LEARN_MORE_CARD: 'FinancialAdvisorEstateCypressAttribute:onboarding:views:LEARN_MORE_CARD',
      REFERRAL_CARD: 'FinancialAdvisorEstateCypressAttribute:onboarding:views:REFERRAL_CARD',
      VALUE_PROPOSITION_BOX_ICON:
        'FinancialAdvisorEstateCypressAttribute:onboarding:views:VALUE_PROPOSITION_BOX_ICON',
      REFER_CLIENTS_BOX:
        'FinancialAdvisorEstateCypressAttribute:onboarding:views:REFER_CLIENTS_BOX',
      GAIN_VISIBILITY_BOX:
        'FinancialAdvisorEstateCypressAttribute:onboarding:views:GAIN_VISIBILITY_BOX'
    }
  },
  plan: {
    views: {
      SAVE_PERCENTAGE: 'FinancialAdvisorEstateCypressAttribute:plan:views:PERCENTAGE_SAVE'
    }
  },
  documentPreview: {
    buttons: {
      MORE_OPTIONS: 'FinancialAdvisorEstateCypressAttribute:documentPreview:buttons:MORE_OPTIONS',
      DELETE: 'FinancialAdvisorEstateCypressAttribute:documentPreview:buttons:DELETE',
      SAVE_CHANGES: 'FinancialAdvisorEstateCypressAttribute:documentPreview:buttons:SAVE_CHANGES',
      VIEW_DETAILS: 'FinancialAdvisorEstateCypressAttribute:documentPreview:buttons:VIEW_DETAILS'
    },
    inputs: {
      TAB_TOGGLE: 'FinancialAdvisorEstateCypressAttribute:documentPreview:inputs:TAB_TOGGLE'
    },
    views: {
      MORE_OPTIONS: 'FinancialAdvisorEstateCypressAttribute:documentPreview:views:MORE_OPTIONS',
      DOCUMENT_NAME: 'FinancialAdvisorEstateCypressAttribute:documentPreview:views:DOCUMENT_NAME',
      FILE_INFO: 'FinancialAdvisorEstateCypressAttribute:documentPreview:views:FILE_INFO',
      SUBTYPE_TAG: 'FinancialAdvisorEstateCypressAttribute:documentPreview:views:SUBTYPE_TAG',
      ANALYSIS: 'FinancialAdvisorEstateCypressAttribute:documentPreview:views:ANALYSIS',
      ANALYSIS_DONE_STATE:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:ANALYSIS_DONE_STATE',
      ANALYSIS_FAILED_STATE:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:ANALYSIS_FAILED_STATE',
      ANALYSIS_SUMMARY:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:ANALYSIS_SUMMARY',
      ANALYSIS_OVERVIEW:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:ANALYSIS_OVERVIEW',
      ANALYSIS_AI_DISCLAIMER:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:ANALYSIS_AI_DISCLAIMER',
      ANALYSIS_OPPORTUNITIES:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:ANALYSIS_OPPORTUNITIES',
      ANALYSIS_EXTRACTED_CONTACTS:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:ANALYSIS_EXTRACTED_CONTACTS',
      ANALYSIS_EXTRACTED_ASSETS:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:ANALYSIS_EXTRACTED_ASSETS',
      EXTRACTED_ASSET_CARD_NAME:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:EXTRACTED_ASSET_CARD_NAME',
      EXTRACTED_ASSET_CARD_PRICE_AMOUNT:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:EXTRACTED_ASSET_CARD_PRICE_AMOUNT',
      EXTRACTED_ASSET_CARD_PRICE_SUB_LABEL:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:EXTRACTED_ASSET_CARD_PRICE_SUB_LABEL',
      EXTRACTED_ASSET_CARD_AMOUNT:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:EXTRACTED_ASSET_CARD_AMOUNT',
      EXTRACTED_ASSET_CARD_AMOUNT_SUB_LABEL:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:EXTRACTED_ASSET_CARD_AMOUNT_SUB_LABEL',
      ANALYSIS_OVERVIEW_TAB:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:ANALYSIS_OVERVIEW_TAB',
      ANALYSIS_TAB_IMPORTED:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:ANALYSIS_TAB_IMPORTED',
      ANALYSIS_TAB_COUNT:
        'FinancialAdvisorEstateCypressAttribute:documentPreview:views:ANALYSIS_TAB_COUNT'
    }
  }
};
